import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import CssBaseline from "@mui/material/CssBaseline";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import { ErrorBoundary } from "react-error-boundary";
import CPSErrorBoundaryFallback, {
  CPSlogError,
} from "exceptionHandler/CPSErrorBoundaryFallback";
import { registerLicense } from "@syncfusion/ej2-base";
import Root from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// Registering Syncfusion license key
registerLicense(`${process.env.REACT_APP_SYNCFUSION_KEY}`);

root.render(
  // <React.StrictMode>
  <>
    <CssBaseline enableColorScheme />
    <Provider store={store}>
      <ErrorBoundary
        onError={CPSlogError}
        FallbackComponent={CPSErrorBoundaryFallback}>
        <Root />
      </ErrorBoundary>
    </Provider>
  </>,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
